export default "__VITE_ASSET__b609c592__"